import { Circle } from "react-konva";

const ANCHOR_SIZE = 7;
const STROKE_COLOR = "#00c875";

const DotMarkers = ({ dots }) => {
  return (
    <>
      {dots.map((dot, i) => (
        <Circle key={i} x={dot.x} y={dot.y} radius={ANCHOR_SIZE} fill={STROKE_COLOR} stroke="#888" strokeWidth={1} listening={false} />
      ))}
    </>
  );
};

export default DotMarkers;
